import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { base_url } from '../Api/Api';
import { Loader } from '../Global/Loader';

import Itemcours from './Itemcours';

const Content = (props) => {

    const [state, setState] = useState({
        data: [],
        loader: true
    })
    const [hasLink, setHasLink] = useState(false)
    const [hasVideo, setHasVideo] = useState(false)
    const [linksList, setLinksList] = useState([])

    useEffect(() => {
        

      base_url.get(`${props.match.params.isHome === 'home' ? 'education-single' : 'item'}/${props.match.params.id}`)
            .then(response => {
                console.log(response.data, 'item')
                setState({
                    ...state,
                    data: response.data,
                    loader: false
                })
                let C =document.getElementsByClassName('webview')
                  let children = C[0].children
                  let list = []
                  for (var i=0 ; i < children.length ; i++ ){
                    if(children[i]){
                      if(children[i].childNodes[0]){
                        // console.log(children[i].childNodes[0], 'children[i].childNodes[0]')
                        if(children[i].childNodes[0].attributes){
                          // console.log(children[i].childNodes[0].attributes, 'attributes')
                          if(children[i].childNodes[0].attributes.href){
                            setHasLink(true)
                            list.push(children[i].childNodes[0].attributes)
                            // href.value
                            // title.value
                          }else if(children[i].childNodes[0].attributes.controls){
                            setHasVideo(true)
                            document.getElementsByTagName("video")[0].setAttribute("controlsList", "nodownload");
                          }
                        }
                      }
                    }
                  }

                  setLinksList(list)
            })
            .catch(error => {
                if (error.response != undefined) {
                    console.log(error)
                    if (error.response.status == 401) {
                        localStorage.clear()
                        props.history.push(`/Entrance`)
                        window.location.reload()
                    }
                }
            })

    }, [])

    const handleExam = (id) => {
        localStorage.setItem('QuizResault', {});
        props.history.push(`/Education/Quiz/${id}/1`)
    }

    const handleTutorial = (id) => {
        props.history.push(`/Education/mycourses/${id}`)
    }

    const gobk = () => {
        props.history.goBack()
    }

    const goCommentPage = () => {
        props.history.push(`/Comments/${state.data.length == 0 ? null : state.data.item_id}`)
    }
    const openPdf = (e, href, title) =>{
      localStorage.setItem('pdfLink', href)
      localStorage.setItem('pdfTitle', title)
      props.history.push(`/Education/course-content/${props.match.params.id}/pdf`)
    }
    return (
        <div className="instructpg main-course">
            <Loader
                active={state.loader} />

            <div className="Header">
                <span className="cat-title">
                    {state.data.length == 0 ? '' : state.data.page_title}
                    <i
                        className="icon-arrow-down-sign-to-navigate"
                        onClick={() => gobk()} ></i>
                </span>
            </div>

            <div className="inner-maincourses">
              <span className="score">
                <i className="icon-black-star-silhouette"></i>
                {state.data.score}
              </span>
                <div dangerouslySetInnerHTML={{ __html: state.data.page_source }}></div>
                {
                  (hasLink && linksList.length )
                    ?( <div className="pdfs">
                      {
                      linksList.map((item, index)=> (
                        <div className="pdf-item">
                          <button 
                            className="btn pdf-btn" 
                            id={index} 
                            onClick={(e)=>openPdf(e,item.href.value,item.title.value )}
                          >
                            {item.title.value} <i className="icon-arrow-down-sign-to-navigate"></i>
                          </button>
                        </div>
                        )
                      )}

                    </div>)
                    :<></>
                }
                {state.data.length == 0 ? null :
                    <div className="list-tags">
                        {state.data.tags.map(item =>
                            <span key={item.name}>{item.name}</span>
                        )}
                    </div>
                }

                {state.data.length !== 0 && state.data.courses.length == 0 ?
                    null
                    :
                    <div className="courses">
                        <h4>کرس درسی</h4>
                        <div className="inner-cours">
                            {state.data.length !== 0 ? state.data.courses.map((info) =>
                                <Itemcours
                                    key={info.id}
                                    title={info.title}
                                    score={info.score}
                                    has_exam={info.has_exam}
                                    has_tutorial={info.has_tutorial}
                                    id={info.id}
                                    read={info.tutorials.map((tutorial)=> {return(tutorial.read)})}
                                    handleExam={() => handleExam(info.exam.id)}
                                    handleTutorial={() => handleTutorial(info.id)} />
                            ) : null}
                        </div>
                    </div>
                }
            </div>

            {state.data.length == 0 ? null : state.data.comment_status ?
                <span
                    onClick={goCommentPage}
                    className="comment-fix" >
                    <i className="icon-comment"></i>
                </span>
                : null
            }


        </div >
    );
}

export default withRouter(Content);